import { useState } from 'react';

export function useDialog(defaultState = {}) {
  const [state, setState] = useState({ open: false, data: null, ...defaultState });

  function onOpen(data = null) {
    setState({ open: true, data });
  }

  function onClose() {
    setState({ open: false, data: defaultState.data || null });
  }

  return { ...state, onOpen, onClose };
}

export default useDialog;
